import Button from "../Button";
import ButtonGroups from "../ButtonGroups";
import "./index.css";

interface ButtonsGroupPanelProps {
  title: string;
  panelButtons: ButtonProps[];
  panelStyle?: React.CSSProperties;
}

const ButtonsGroupPanel = ({
  panelStyle = {},
  title,
  panelButtons,
}: ButtonsGroupPanelProps) => {
  return (
    <div className="base-buttons-group-panel" style={panelStyle}>
      <div className="base-buttons-group-panel_title">{title}</div>
      <ButtonGroups>
        {panelButtons &&
          panelButtons.map((button, index) => (
            <Button key={index} {...button} />
          ))}
      </ButtonGroups>
    </div>
  );
};

export default ButtonsGroupPanel;
